<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          결과
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Result</a>
          </li>
      </ul>
    </div>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <b-row>
            <b-col>
              <strong>점검 결과 상세</strong>
              <strong style="float:right;">점검 시각 ({{model.scan_time | datetime}})</strong>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>에이전트</div>
                <div title="" v-if="model && model.agent">
                  {{model.agent.name}}
                  <span v-if="model.agent.name != model.agent.host">
                    ({{model.agent.host}})
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP 주소(외부)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_public}}</div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <div class="m-1" title="" v-b-tooltip.hover>IP 주소(내부)</div>
                <div title="" v-if="model && model.agent">{{model.agent.ip_addr_private}}</div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="점검에 소요된 시간을 표시합니다 수동 점검의 경우 대략적인 시간을 표시합니다">
                  점검 소요 시간
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div>
                  {{model.scanning_time}}
                </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <div class="m-1" v-b-tooltip.hover>폴더 / 파일</div>
                <div>{{model.scan_folder | number}} 개 / {{model.scan_count | number}} 개 </div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="탐지된 개수를 표시합니다">
                  탐지 건수
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div> {{model.detect_count | number}} 개</div>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <span class="m-1 font-weight-bold" v-b-tooltip.hover.right title="탐지된 내역 중 격리 모드에 해당되어 격리된 수를 표시합니다">
                  격리 건수
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <div> {{model.backup_count | number}} </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="model.setting && model.setting.rule">
          <b-row v-if="model.setting && model.setting.rule">
            <b-col md="12">
              <b-button block href="#" variant="success" v-b-tooltip.hover.top title="점검을 진행 했을 때의 점검 정책을 표시합니다" class="btn-add">
                설정
                <span>
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </b-button>
            </b-col>
          </b-row>
          <hr v-if="model.setting && model.setting.rule">
          <b-row class="text-center" v-if="model.setting && model.setting.rule">
            <b-col>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="점검시 사용하는 정책을 설정합니다">
                    * 점검 정책
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>

                </div>
                <b-form-checkbox-group id="ph_status" v-model="model.setting.rule" :disabled="true">
                  <b-form-checkbox value="Regex">정규식</b-form-checkbox>
                  <b-form-checkbox value="Hash">해시</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">유사도</b-form-checkbox>
                  <b-form-checkbox value="OB">난독화</b-form-checkbox>
                  <!-- <b-form-checkbox value="ML">Machine Learning</b-form-checkbox> -->
                </b-form-checkbox-group>
              </b-form-group>
              <br>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="실시간 모니터링 여부를 설정합니다">
                    실시간 모니터링
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group :disabled="true" id="ph_realtime_mode_type" v-model="model.setting.realtime_mode">
                  <b-form-radio :value="true">사용</b-form-radio>
                  <b-form-radio :value="false">미사용</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="4" label="">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="점검 일정을 설정합니다 최대 10개까지 설정 가능하며 새벽 또는 서버 자원의 부하가 없는 시간대를 권장합니다">
                    * 점검 일정
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                    <br>
                    <small>최대 10개의 일정 설정 가능</small>
                  </span>
                </div>
                <Schedule :readonly="true" :now_schedule="model.setting.schedule" :hide_text="true" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="2">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="탐지된 웹쉘 파일의 백업 여부를 설정합니다 백업 후 해당 파일을 웹에서 접근할 수 없습니다 권장되는 설정이지만 오탐의 파일이 백업될 수 있습니다">
                    격리 모드
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group :disabled="true" style="display:inline-block" v-model="model.setting.backup_mode">
                  <b-form-radio :value="false">수동</b-form-radio>
                  <b-form-radio :value="true">자동</b-form-radio>
                </b-form-radio-group>
                [
                <b-form-checkbox-group :disabled="true" style="display:inline-block" v-model="model.setting.backup_type_list">
                  <b-form-checkbox value="Regex">정규식</b-form-checkbox>
                  <b-form-checkbox value="Hash">해시</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">유사도</b-form-checkbox>
                  <!-- <b-form-checkbox value="OB">난독화</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="ML">Machine Learning</b-form-checkbox> -->
                </b-form-checkbox-group>
                ] <br> <small class="text-danger">* 난독화는 자동 격리를 사용할 수 없습니다</small>
              </b-form-group>
            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.bottom title="격리 경로를 설정합니다 해당 경로가 존재하지 않을 경우 해당 경로에 폴더를 자동으로 생성합니다 기본값은 윈도우의 경우 'C:\wfinder_backup', 리눅스의 경우 '/opt/f1/wsfinder_backup'이 설치시 기본값으로 지정됩니다">
                    격리 경로
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                  <b-form-input placeholder="경로를 입력하세요" :disabled="true" id="input-small3" type="text" v-model="model.setting.backup_path"></b-form-input>
                  <!-- <b-button size="sm" variant="link" @click="modal_scan_list_history = true">이전 기록</b-button> -->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <hr>
              <b-button class="btn-addition" style="position: relative; top:-30px; width: 80%;" v-b-toggle.collapse-1-inner size="sm" variant="light">추가 옵션</b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="점검 대상에서 확장자로 필터링할 수 있습니다 특정 파일만 모니터링 하는 경우에 사용합니다 ">
                      확장자 설정
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                    <b-form-input :disabled="true" type="text" v-model="converter"></b-form-input>
                  </b-input-group>
                  <small class="help-block">확장자 설정, 예) txt,php,aspx,js, ...</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="모니터링하는 폴더에서 조건 이하의 크기를 가진 파일만 검사합니다">
                      최대 파일 사이즈
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                      <b-form-input :disabled="true" type="number" v-model="model.setting.max_filesize"></b-form-input>
                  </b-input-group>
                  <small class="help-block">기본 : 10M</small>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="업데이트 되는 시스템 패턴을 자동으로 적용하여 점검하는지 여부를 설정합니다 해당 설정은 활성화를 권장합니다 미사용할 경우 업데이트된 패턴을 수동으로 업데이트할 수 있습니다">
                      시스템 패턴 자동 적용
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                    <!-- 시스템 패턴 자동 적용 -->
                  </div>
                  <b-form-radio-group v-if="model.setting" v-model="model.setting.is_allow_system" :disabled="true">
                    <b-form-radio :value="true">사용</b-form-radio>
                    <b-form-radio :value="false">미사용</b-form-radio>
                    <b-button size="sm" variant="success" :disabled="true" class="btn-add">
                      <b-badge pill variant="warning" >{{ model.available_system_pattern_count | number }}</b-badge>
                      <span v-if="!model.is_testing">
                        시스템 패턴 추가 적용이 가능합니다
                      </span>
                      <span v-else>
                        테스트 요청, 메일로 결과를 알려 드립니다
                      </span>
                    </b-button>
                  </b-form-radio-group>
                  <small class="text-danger">사용을 권장합니다</small>
                </b-form-group>
              </b-col>
            </b-row>
          <!--  <hr>
          <b-row class="text-center">
            <b-col sm="12">
              <p style="display:inline-block; cursor: pointer;" @click="model.setting.limit_mode = !model.setting.limit_mode">
                <span v-b-tooltip.hover.right title="설치된 서버의 자원을 모니터링 합니다 설정한 한계치 도달시 메일 알림을 수신할 수 있습니다">
                  자원 모니터링 알림
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <i v-if="model.setting.limit_mode" class="fa fa-refresh fa-spin"></i>
              </p>
              <c-switch :disabled="true" class="float-right" color="success" label variant="pill" v-model="model.setting.limit_mode"/>
              <br>
              <small class="text-danger">시스템 자원이 임계치 이상일 경우 최초 1회 알림 발생 되며, 정상 기준이하시 재알림이 가능합니다. 임계치는 90%, 정상 기준은 60% 를 권장합니다 </small>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 임계치(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk 정상(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row> -->
          </b-collapse>
          <hr>
          <b-row>
            <b-col md="12">
              <b-button block href="#" variant="danger">
                탐지 목록
              </b-button>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col md="12">
              <b-form-group>
                <pre class="text-left" v-if="detect_list" style="margin:0 auto; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; max-height: 500px; max-width: 1500px; overflow: auto;">{{detect_list}}</pre>
                <span v-else>탐지된 내용이 없습니다</span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button v-if="!(id || result_data) && detect_list.length" size="sm" variant="success" @click="save_rs" class="btn-add"> 다운로드 </b-button>
          <b-button block v-if="(id || result_data) && detect_list.length" size="sm" variant="success" @click="save_rs" class="btn-add"> 다운로드 </b-button>
          <b-button v-if="!id && !result_data" size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
